import { all, put, takeEvery } from "redux-saga/effects";
import { fetcher, getErrorMsg, handleError } from "lib/fetch";
import * as actions from "./actions";

const url = "plant-products";

function* loadPlantProducts(action) {
  try {
    const { company_id, token } = action.payload;
    const res = yield fetcher.get(`${url}/${company_id}`, token);
    yield put(actions.loadPlantProducts.success(res.data));
  } catch (error) {
    handleError(error);
    yield put(actions.loadPlantProducts.failure(getErrorMsg(error)));
  }
}

function* savePlantProducts(action) {
  try {
    const { payload, token } = action.payload;
    const res = yield fetcher.post(`${url}/create`, payload, token);
    yield put(actions.savePlantProducts.success(res.data));
  } catch (error) {
    handleError(error);
    yield put(actions.savePlantProducts.failure(getErrorMsg(error)));
  }
}

function* exportPlantProducts(action) {
  try {
    const { params, token } = action.payload;
    const res = yield fetcher.post(`${url}/export`, params, token);
    yield put(actions.exportPlantProducts.success(res.data));
    fetcher.download(res.data.data);
  } catch (error) {
    handleError(error);
    yield put(actions.exportPlantProducts.failure(getErrorMsg(error)));
  }
}

function* importPlantProducts(action) {
  try {
    const { file, token } = action.payload;
    const formData = new FormData();
    formData.append("file_name", file.originFileObj);
    const res = yield fetcher.upload(`${url}/import`, formData, token);
    yield put(actions.importPlantProducts.success(res.data));
  } catch (error) {
    handleError(error);
    yield put(actions.importPlantProducts.failure(getErrorMsg(error)));
  }
}

export default function* watchPlantProduct() {
  yield all([
    takeEvery(actions.LOAD_PLANT_PRODUCTS.REQUEST, loadPlantProducts),
    takeEvery(actions.SAVE_PLANT_PRODUCTS.REQUEST, savePlantProducts),
    takeEvery(actions.EXPORT_PLANT_PRODUCTS.REQUEST, exportPlantProducts),
    takeEvery(actions.IMPORT_PLANT_PRODUCTS.REQUEST, importPlantProducts),
  ]);
}